/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_JahrgangsstufeInputs */

const de__field_jahrgangsstufe = /** @type {(inputs: _Field_JahrgangsstufeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahrgangsstufe`)
};

/**

* @param {_Field_JahrgangsstufeInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_jahrgangsstufe = /** @type {((inputs?: _Field_JahrgangsstufeInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_JahrgangsstufeInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_jahrgangsstufe(inputs)
});